import { DIRECTORY_DOCUMENT_URL } from "../constants";
import { apiSlice } from "./apiSlice";

export const directoryDocumentApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDirectoryDocument: builder.query({
      query: () => DIRECTORY_DOCUMENT_URL,
      providesTags: ["DirectoryDocument"],
    }),
    uploadDirectoryDocument: builder.mutation({
      query: (formData) => ({
        url: DIRECTORY_DOCUMENT_URL,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["DirectoryDocument"],
    }),
    deleteDirectoryDocument: builder.mutation({
      query: () => ({
        url: DIRECTORY_DOCUMENT_URL,
        method: "DELETE",
      }),
      invalidatesTags: ["DirectoryDocument"],
    }),
  }),
});

export const {
  useGetDirectoryDocumentQuery,
  useUploadDirectoryDocumentMutation,
  useDeleteDirectoryDocumentMutation,
} = directoryDocumentApiSlice;
